import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { Image } from 'cloudinary-react'

import { useStyles } from './CTABannerHiring_style'
import { Typography, Box, Hidden } from '@material-ui/core'

import RouteMap from 'assets/RouteMap'
import { UserContext } from 'contexts/UserContext'
import Button from 'shared/components/Button/Button.jsx'

const CTABannerHiring = (props) => {
    const { userType, type } = props
    const classes = useStyles()
    const userContext = useContext(UserContext)
    const employerSignupUrl = userContext?.user
        ? RouteMap.Page('users/company_profiles/edit/')
        : `${RouteMap.Page('login')}?userType=employer`

    const handleNewEmployerSignup = () => {
        window.location.href = employerSignupUrl
    }

    return (<>
        {(!userType || userType === 'employer') &&
        <Box className={classes.container}>
            <Box className={classes.containerLeft}>
                <Box className={classes.alertTextContainer}>
                    <Typography
                        variant='h3'
                        component='p'
                        className={classes.alertText}
                    >
                        <FormattedMessage id='item_index.alert.company.title' />
                    </Typography>
                </Box>
                <Button
                    variant='cta-primary'
                    className={classes.alertButtonStyle}
                    onClick={handleNewEmployerSignup}
                >
                    <FormattedMessage id='item_offers.post_your_jobs' />
                </Button>
            </Box>
            <Hidden smDown>
                <Box className={classes.containerRight}>
                    <Image
                        className={classes.image}
                        cloudName='studentbe'
                        publicId='student-be-assets/two_girls_working_no_bg'
                        alt='Student.be logo'
                    />
                </Box>
            </Hidden>
        </Box>}
    </>
    )
}

export default CTABannerHiring
